import { UserCardSkeleton } from '../../../components/Skeleton';

export interface DiscoverSkeletonProps {
  /** Number of user card skeletons to show (default: 6) */
  count?: number;
  className?: string;
}

export function DiscoverSkeleton({ count = 10, className }: DiscoverSkeletonProps) {
  return <UserCardSkeleton count={count} className={className} />;
}

export default DiscoverSkeleton;
